const SERVICE_LOCAL = '59:8082';
const SERVICE_LOCAL_SC = '199:8086';
const SERVICE_LOCAL_CA = '31:13001';
const SERVICE_LOCAL_PF = '31:8082';
const SERVICE_TEST = '242:10101';
const SERVICE_FILE = '242';

const SERVICE_USING = SERVICE_LOCAL_PF;

exports.vue = {
    devServer: {
        port: '12108',
        open: true,
        proxy: {
            '^(\/(standalonfile|tbfile|upload))': {
                target: `http://192.168.1.${SERVICE_FILE}:10108`,
                changeOrigin: true,
                pathRewrite: {
                    '^/': '/'
                }
            },
            '/hzbtenderagentzero': {
                target: `http://192.168.1.${SERVICE_USING}`,
                changeOrigin: true,
                pathRewrite: {
                    '^/hzbtenderagentzero': '/'
                }
            },
            '/pingbiao': {
                target: `http://192.168.1.${SERVICE_USING}`,
                changeOrigin: true,
                pathRewrite: {
                    '^/hzbtenderagentzero': '/'
                }
            },
            '/newpingbiao': {
                target: `http://192.168.1.${SERVICE_USING}`,
                changeOrigin: true,
                pathRewrite: {
                    '^/hzbtenderagentzero': '/'
                }
            },
            '/FaBiao': {
                target: `http://192.168.1.${SERVICE_USING}`,
                changeOrigin: true,
                pathRewrite: {
                    '^/hzbtenderagentzero': '/'
                }
            },
            'Zbdl|res|FangAn|file': {
                target: `http://192.168.1.${SERVICE_USING}`,
                changeOrigin: true,
                pathRewrite: {
                    '^/': '/'
                }
            },
            '/api': {
                target: `http://192.168.1.${SERVICE_LOCAL_CA}`,
                changeOrigin: true,
                pathRewrite: {
                    '^/hzbtenderagentzero': '/'
                }
            },
            '/tool/makezbfile': {
                target: `http://192.168.1.242:10111/makezbfile/`,
                changeOrigin: true,
                pathRewrite: {
                    '^/': '/'
                }
            }
        },
    },
    pages: {
        index: {
            entry: './enters/hzb/index.js',
            template: './public/index.html',
            faviconPath: './hzb/favicon.ico',
        },
        zchz: {
            entry: './enters/zchz/index.js',
            template: './public/index.html',
            faviconPath: './zchz/favicon.ico',
        },
    },
}

exports.project = {
    'project-type': 'pc',

    assetsDir: 'static',
    
    ui: {
        element: true,
        mint: false
    },

    router: {
        'base-name': '',
    },

    //ajax类型axios或jquery，用法相同
    ajax: 'jquery',

    sentry: {
        dsn: 'https://7b4c6605f37f4ea89577dfa9587a3368@o367512.ingest.sentry.io/5671082',
        enabled: false
    },

    cnzz: false
}